export enum Location {
    ONLINE = 'online',
    LABORATORY_CENTER = 'laboratory_center',
}

